import Entity from 'utilities/entity';

class Training extends Entity {

}

export default new Training();